import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import {
    Typography,
    IconButton,
    Grid,
    List,
    ListItem,
} from '@material-ui/core';

import EmailIcon from '@material-ui/icons/Email';
import LinkedInIcon from '@material-ui/icons/LinkedIn';


import {Image} from 'components/atoms';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(6, 0),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(12, 0),
        },
        background: theme.palette.background.footer,
    },
    footerContainer: {
        maxWidth: theme.layout.contentWidth,
        width: '100%',
        margin: '0 auto',
        padding: theme.spacing(0, 2),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 8),
        },
    },
    logoContainerItem: {
        paddingTop: 0,
    },
    logoContainer: {
        width: 140,
        height: 31.3,
    },
    logoImage: {
        width: '100%',
        height: '100%',
    },
    groupTitle: {
        textTransform: 'uppercase',
        color: theme.palette.primary.dark,
        marginBottom: theme.spacing(1),
    },
    socialIcon: {
        padding: 0,
        marginRight: theme.spacing(1),
        color: 'rgba(255,255,255,.6)',
        '&:hover': {
            background: 'transparent',
        },
        '&:last-child': {
            marginRight: 0,
        },
    },
    icon: {
        fontSize: 24,
    },
    menuListContainer: {
        padding: '0 !important',
    },
    menu: {
        display: 'flex',
    },
    menuItem: {
        margin: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    menuGroupItem: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1 / 2),
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    menuGroupTitle: {
        textTransform: 'uppercase',
        color: 'white',
    },
    divider: {
        width: '100%',
    },
    navLink: {
        color: 'rgba(255,255,255,.6)',
    },
}));

const Footer = props => {
    const {pages, className, ...rest} = props;

    React.useEffect(() => {
        let i, e, t, s = window.legal = window.legal || [];
        if (s.SNIPPET_VERSION = "3.0.0", i = "https://widgets.openli.com/v1/legal.js", !s.__VERSION__) {
            if (s.invoked)
                console.info("legal.js: The initialisation snippet is included more than once on this page, and does not need to be.");
            else {
                for (s.invoked = !0, s.methods = ["cookieConsent", "document", "ensureConsent", "handleWidget", "signup", "user"],
                         s.factory = function (t) {
                             return function () {
                                 let e = Array.prototype.slice.call(arguments);
                                 return e.unshift(t), s.push(e), s
                             }
                         }, e = 0; e < s.methods.length; e++) t = s.methods[e], s[t] = s.factory(t);
                s.load = function (e, t) {
                    let n, o = document.createElement("script");
                    o.setAttribute("data-legalmonster", "sven"), o.type = "text/javascript", o.async = !0, o.src = i, (n = document.getElementsByTagName("script")[0]).parentNode.insertBefore(o, n), s.__project = e, s.__loadOptions = t || {}
                }, s.widget = function (e) {
                    s.__project || s.load(e.widgetPublicKey), s.handleWidget(e)
                }
            }
        }
        legal.widget({type: "cookie", widgetPublicKey: "TMtSARvabecRGwkDAjVRh1MK"})
    }, [])

    const classes = useStyles();

    const {landings, resources} = pages;

    const MenuGroup = props => {
        const {item} = props;
        return (
            <List disablePadding className={classes.menuItem}>
                <ListItem disableGutters className={classes.menuGroupItem}>
                    <Typography variant="body2" className={classes.menuGroupTitle}>
                        {item.groupTitle}
                    </Typography>
                </ListItem>
                {item.pages.map((page, i) => (
                    <ListItem disableGutters key={i} className={classes.menuGroupItem}>
                        <Typography
                            variant="body2"
                            component={'a'}
                            href={page.href}
                            onClick={page.onClick}
                            className={clsx(classes.navLink, 'submenu-item')}
                        >
                            {page.title}
                        </Typography>
                    </ListItem>
                ))}
            </List>
        );
    };

    const ResourcePages = () => {
        const {
            blog,
            helpCenter,
        } = resources.children;

        return (
            <div className={classes.menu}>
                <div>
                    <MenuGroup item={blog}/>
                </div>
                <div>
                    <MenuGroup item={helpCenter}/>
                </div>
            </div>
        );
    };

    const LandingPages = () => {
        const {company} = landings.children;

        return (
            <div className={classes.menu}>
                <div>
                    <MenuGroup item={company}/>
                </div>
            </div>
        );
    };


    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <div className={classes.footerContainer}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={2}>
                        <List disablePadding>
                            <ListItem disableGutters className={classes.logoContainerItem}>
                                <div className={classes.logoContainer}>
                                    <a href="/" title="REVLOCK">
                                        <Image
                                            className={classes.logoImage}
                                            src="https://s3.amazonaws.com/content.rev-lock.com/images/transparent_logo.png"
                                            alt="REVLOCK"
                                            lazy={false}
                                        />
                                    </a>
                                </div>
                            </ListItem>
                            <ListItem disableGutters>
                                <IconButton className={classes.socialIcon}
                                            onClick={() => window.open("mailto:sales@rev-lock.com")}>
                                    <EmailIcon className={classes.icon}/>
                                </IconButton>
                                <IconButton className={classes.socialIcon}
                                            onClick={() => window.open('https://www.linkedin.com/company/revlock/')}>
                                    <LinkedInIcon className={classes.icon}/>
                                </IconButton>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={10} className={classes.menuListContainer}>
                        <Grid container spacing={0}>
                            <Grid item>
                                <LandingPages/>
                            </Grid>
                            <Grid item>
                                <ResourcePages/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

Footer.propTypes = {
    className: PropTypes.string,
    pages: PropTypes.object.isRequired,
};

export default Footer;
